import React, { useEffect, useState } from "react";
import { Select } from "antd";
import axiosInstance from '../../Config/axiosConfig';

const { Option } = Select;

const AccountTypeStep = ({ selectedClass, setSelectedClass }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axiosInstance.post('Public/get-lookups');
        if (response.data.code === 200 && response.data.data?.educationClasses) {
          const allClasses = response.data.data.educationClasses.map(cls => ({
            id: cls.id,
            name: cls.name,
          }));
          setClasses(allClasses);
        }
      } catch (error) {
        console.error('Error fetching classes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

  return (
    <div className="step-content">
      <h3>Your Class Level</h3>

      <Select
        placeholder="Select your class/level"
        value={selectedClass}
        onChange={setSelectedClass}
        style={{ width: "100%", marginTop: 10, height: 40 }}
        loading={loading}
      >
        <Option value="" disabled>
          -- Please select a class --
        </Option>
        {classes.map((cls) => (
          <Option key={cls.id} value={cls.id}>
            {cls.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default AccountTypeStep;
